module.exports = __webpack_public_path__ + "static/img/strona_011.534465a2.jpg";